import { t } from 'i18next'
import * as Yup from 'yup'
import { FormField } from 'src/enums/Form'
import { TipoRepresentacion } from 'src/interfaces/Catalog'
import { RepresentanteProcesal } from 'src/interfaces/EscritosLegales'
import { validDNI } from 'src/utils/validations'

export const enum TipoRepresentacionMaster {
  ABOGADO = 2,
  GRADUADO_SOCIAL = 4,
  PROCURADORES = 16
}

export const initialValues: RepresentanteProcesal = {
  [FormField.INTERVINIENTE_REPRESENTACION_TIPO]: null,
  [FormField.COMUNIDAD_AUTONOMA]: null,
  [FormField.PROVINCIA]: null,
  [FormField.COLEGIO]: null,
  [FormField.INTERVINIENTE_REPRESENTANTE_PROCESAL_NIF]: '',
  [FormField.CODIGO_COLEGIADO]: '',
  [FormField.INTERVINIENTE_NOMBRE]: '',
  [FormField.INTERVINIENTE_PRIMER_APELLIDO]: '',
  [FormField.INTERVINIENTE_SEGUNDO_APELLIDO]: '',
  [FormField.INTERVINIENTE_REPRESENTANTE_PROCESAL_EMAIL]: '',
  [FormField.ENTIDAD]: null
}

export function tipoRepresentacionProfesional(tipoRepresentacion?: TipoRepresentacion): boolean {
  if (!tipoRepresentacion) {
    return false
  }
  const tipos: number[] = [
    TipoRepresentacionMaster.ABOGADO,
    TipoRepresentacionMaster.GRADUADO_SOCIAL,
    TipoRepresentacionMaster.PROCURADORES
  ]
  return tipos.includes(tipoRepresentacion?.id)
}

export const validationSchema = (isMonitorio: boolean): Yup.AnyObjectSchema => {
  return Yup.object().shape({
    [FormField.INTERVINIENTE_REPRESENTANTE_PROCESAL_NIF]: Yup.string().when(
      [FormField.INTERVINIENTE_REPRESENTACION_TIPO, '$isMonitorio'],
      {
        is: (tp: TipoRepresentacion) => tipoRepresentacionProfesional(tp) && !isMonitorio,
        then: Yup.string()
          .required(t('form.validation.required.default'))
          .test('validDNI', t('form.validation.not_valid_number'), value =>
            value ? validDNI(value) : false
          )
      }
    ),
    [FormField.CODIGO_COLEGIADO]: Yup.string().when(FormField.INTERVINIENTE_REPRESENTACION_TIPO, {
      is: (tp: TipoRepresentacion) => tipoRepresentacionProfesional(tp),
      then: Yup.string().required(t('form.validation.required.default'))
    }),
    [FormField.COLEGIO]: Yup.object()
      .nullable()
      .when(FormField.INTERVINIENTE_REPRESENTACION_TIPO, {
        is: (tp: TipoRepresentacion) => tipoRepresentacionProfesional(tp),
        then: Yup.object()
          .nullable()
          .required(t('form.validation.required.default'))
      }),
    [FormField.ENTIDAD]: Yup.object()
      .nullable()
      .when(FormField.INTERVINIENTE_REPRESENTACION_TIPO, {
        is: (tp: TipoRepresentacion) => tp && !tipoRepresentacionProfesional(tp),
        then: Yup.object()
          .nullable()
          .required(t('form.validation.required.default'))
      })
  })
}
